export default "__VITE_ASSET__5efee7ac__"